import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	errorStateTitle: {
		id: 'eoc.heartbeats.common.team.error-state-title.no-translate',
		defaultMessage: 'We couldn’t load the heartbeats',
		description: 'Title that will be shown when there is error in fetching heartbeats',
	},
	errorStateDescription: {
		id: 'eoc.heartbeats.common.team.error-state-description.no-translate',
		defaultMessage: 'Refresh the page to try again.',
		description: 'Description that will be shown when there is error in fetching heartbeats',
	},
	errorStateCTA: {
		id: 'eoc.heartbeats.common.team.error-state-cta.no-translate',
		defaultMessage: 'Refresh',
		description: 'Call to action that will be shown when there is error in fetching heartbeats',
	},
});

export default messages;
